'use strict';
import '@fancyapps/fancybox';

;(function($) {

    $(window).on('load', function () {
        $().fancybox({
            selector : '[rel*="lightbox"]'
        });
    });

}($));
